import React from 'react';

const ThreeColumnCardComponent = ({ data }) => {
  return (
    <div className='d-flex flex-column flex-lg-row  three-column-container'>
      {data.map(info => {
        const { description, headline } = info?.fields;
        const { content } = description?.content[0];
        return (
          <div className='coulm-container d-flex flex-column align-items-lg-center align-items-start'>
            <h3 className='column-heading text-center'>
              {headline} <span className='d-sm-block d-md-none'>:</span>{' '}
            </h3>
            {content.map(desc => (
              <span className='column-desc text-lg-center text-left'>{desc?.value}</span>
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default ThreeColumnCardComponent;
